import React from 'react';
import './MainContent.css';
import BackgroundImage from 'assets/background.jpg';

const MainContent = () => {
  return (
    <div className='main__content'>
      <img src={BackgroundImage} alt='Main Background' className='post__image' />
      <div className='gradient' />
      <div className='main__content-text'>
        <p className='main__content-title'>Welcome to Videogames Nation</p>
        <p className='main__content-description'>Your daily dose of videogames.</p>
      </div>
    </div>
  );
};

export default React.memo(MainContent);
